import type { RecipientMap } from '@getaccept/editor-lib/src/types/models';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { PusherClient } from '@getaccept/pusher';
import { EditorViewService } from '../../api/services/editor-view.service';
export class ContractHelper {
  static async getToken(contractId: string, signingPageUrl: string) {
    const url = signingPageUrl.split('/a/');
    const authId = url[1];
    const recipientId = url[0].slice(url[0].lastIndexOf('/') + 1);
    try {
      const { jwt } = await EditorViewService.getToken(contractId, authId, recipientId);
      return jwt;
    } catch (error) {
      return null;
    }
  }

  static async connectPusher(jwt: string, pusherClient: PusherClient) {
    try {
      await pusherClient.connect(jwt);
    } catch (e) {
      console.error('pusher error', e);
    }
  }

  static async createPusherClient(jwt: string) {
    try {
      const pusherClient = new PusherClient(`https://${process.env.VUE_APP_PUBLIC_API_BASE_URL}`);
      await ContractHelper.connectPusher(jwt, pusherClient);
      return pusherClient;
    } catch (e) {
      return null;
    }
  }

  static async loadContract(jwt: string) {
    try {
      return await EditorViewService.getDocument(jwt);
    } catch (error) {
      return null;
    }
  }

  static async getSigningPageUrl(contractId: string) {
    try {
      return await EditorViewService.getSigningPageUrl(contractId);
    } catch (error) {
      return null;
    }
  }

  static findMappedRecipient(id: string, recipient: Recipient, recipientMaps: RecipientMap[]) {
    return recipientMaps.find(
      recipientMap =>
        recipientMap.contractRecipientId === id && recipientMap.dsrRecipientId === recipient.id
    );
  }
}
